import React, { FC, useEffect } from 'react';

import { Box } from '@mui/material';
import {
  adminActions,
  getPharmacyDetails,
  resetStatus,
  ContractTypes,
  successOrSelector,
} from '@pharmaplan/common';
import AllowanceAdminWorkshift from '../../EditWorkshift/AllowanceAdminWorkshift';

import CustomTextField from '../../../common/CustomTextField';
import genericClasses from '../../../../theme/GenericClasses';
import strings from '../../../../localization';
import { useAppDispatch } from '../../../../hooks/useAppDispatch';
import {
  ICustomBack,
  resetDrawer,
  setBack,
  setFooter,
} from '../../../../actions/drawerActions';
import { IPharmacyListActionsParams } from '../../../../hooks/Admin/PharmacyList/usePharmacyListAction';
import LongTermHourlyRates from '../../../SelfService/Workshifts/AddWorkshift/LongTermHourlyRates';
import useAdminCreateWorkshift from '../../../../hooks/Admin/Workshift/useAdminCreateWorkshift';
import { showSuccess } from '../../Profile/Pharmacist/PharmacistViewProfile/helper';
import AllowanceWorkshift from '../../../SelfService/Workshifts/AllowanceWorkshift';
import WorkshiftForm from '../../../SelfService/Workshifts/WorkshiftForm';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import useSelfService from '../../../../hooks/useSelfService';
import useRecurrence from '../../../../hooks/useRecurrence';

import styles from './style';
import AdminLongTermHourlyRates from './AdminLongTermHourlyRates';

const successAction = [
  adminActions.createWorkshift,
  adminActions.adminCreateShiftContract,
];

const AdminCreateWorkshift: FC<
  IPharmacyListActionsParams & { back?: ICustomBack }
> = ({ pharmacyId, name, back }) => {
  const dispatch = useAppDispatch();
  const { isSelfService } = useSelfService();
  const LongTermRateComponent = isSelfService ? LongTermHourlyRates : AdminLongTermHourlyRates;

  const success = useAppSelector((state) =>
    successOrSelector(successAction, state));

  const { formik } = useAdminCreateWorkshift({ pharmacyId, name });
  const isLongTerm = formik.values.contractType === ContractTypes.longTerm;

  const { handleSubmit } = formik ?? {};
  useRecurrence(formik);

  useEffect(() => {
    if (!isSelfService) {
      dispatch(getPharmacyDetails(pharmacyId));
    }
    dispatch(
      setFooter({
        show: true,
        pagination: {
          show: false,
        },
        buttons: {
          show: true,
          primaryButton: {
            label: strings.submit,
            onClick: handleSubmit,
          },
        },
      }),
    );
    if (back) {
      dispatch(setBack(back));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (success) {
      showSuccess(dispatch, strings.workshiftCreatedSuccessfully);
      dispatch(resetStatus(successAction));
      dispatch(resetDrawer());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  return (
    <Box sx={[styles.container, genericClasses.borderNoneTextField]}>
      <CustomTextField
        label={strings.pharmacyName}
        formik={formik}
        name="name"
        id="name"
        disabled
      />

      <WorkshiftForm formik={formik} isSeries />

      {isLongTerm ? (
        <LongTermRateComponent formik={formik} />
      ) : (
        <AllowanceWorkshift
          pharmacyId={pharmacyId}
          formik={formik}
          isAdmin
          renderHourlyRate={<AllowanceAdminWorkshift formik={formik} />}
        />
      )}

      {isLongTerm && (
        <CustomTextField
          variant="outlined"
          formik={formik}
          id="allowanceNotes"
          placeholder={strings.allowancePlaceholder}
          label={strings.allowances}
          name="allowanceNotes"
          multiline
          maxLength={200}
          customClass={genericClasses.borderNoneTextField}
        />
      )}

      <CustomTextField
        variant="outlined"
        formik={formik}
        id="notes"
        placeholder=" "
        label={strings.notes}
        name="notes"
        multiline
        maxLength={200}
        customClass={genericClasses.borderNoneTextField}
      />
    </Box>
  );
};

export default AdminCreateWorkshift;
